module.exports = __webpack_public_path__ + "static/media/redux-logo-white.f162ef34.svg";